import React, { Component } from 'react';
import { Button, Image, Glyphicon } from 'react-bootstrap';
import { history } from '../helpers';
import AuthService from "../services/auth.service";
import '../content/css/TrialComponents.css';

const img = require("../content/images/iconmonstr-product-1.svg");
const logo = require("../content/images/legly_logo_color.svg");

export default class TrialPage extends Component {
    constructor(props) {
        super(props);

        this.authService = new AuthService();
    }

    componentDidMount() {
        if (this.authService.isAuthenticated()) {
            history.push("/");
        }

    }

    handleTrialClick = () => {
        if (this.authService.isAuthenticated() || this.authService.isFreemium() || this.authService.isGuest()) {
            history.push("/");
        } else {
            window.location.href = 'https://www.legly.io/try-for-free';
        }
    }

    handleLoginClick = () => {
        if (!this.authService.isAuthenticated()) {
            this.authService.login();
        }
    }

    handleBecomeCustomerClick = () => {
        if (!this.authService.isAuthenticated()) {
            window.location.href = 'https://www.legly.io/get-legly';
        }
    }

    render() {
        let isGuest = this.authService.isGuest();
        let trialButton = isGuest ? "Continue Free Review" : "Start Free Review";
        return (
            <div className="trial-page">
                <Image className="logo" src={logo} />
                <h1>Contract Review Made Simple</h1>
                <h3>Free Limited Review</h3>
                <div>
                    <Button onClick={this.handleTrialClick}>{trialButton}</Button>
                    <Button onClick={this.handleBecomeCustomerClick}>Get Full Access</Button>
                    <p>By using this service you agree to our <a href="https://www.legly.io/terms-of-service">Terms of Service</a>.</p>
                </div>

                <div className="boxes">
                    <h3>Full access would give you:</h3>
                    <div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="tags" />
                                <h4>More contract types</h4>
                                <p>Our service can handle a range of different contracts, including NDAs and EULAs.</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="wrench" />
                                <h4>Custom review parameters</h4>
                                <p>Want to tailor exactly what clauses to look for? We have that covered.</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="duplicate" />
                                <h4>Compare versions</h4>
                                <p>See how different versions of a contract differ from each other. What's been changed?</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="print" />
                                <h4>Export to Word</h4>
                                <p>Select what you find important from our review and export it to PDF or Word.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TrialPage.js